/** Reserved height of a checkout payment area; the slot and its skeleton share it so loading never resizes it. */
export const CHECKOUT_PAYMENT_MIN_HEIGHT_PX = 300;
